import React, { useContext, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import { PublicUsersProfileContext } from '../../../services/public-users-profile/public-users-profile.context';
import { About } from './about';
import { UserAvatar } from './avatar';
import { PublicMeetings } from './public-meetings';
import { UserInfo } from './user-info';

export const PublicProfile = () => {
  const { user } = useParams();
  const { getUser, notFound } = useContext(PublicUsersProfileContext);

  useEffect(() => {
    user && getUser(user);
  }, [user]);

  return (
    <Box pb={5} pt={0} width='100%'>
      {notFound ? (
        <Box>
          <Typography>User not found!</Typography>
          <Link to='/meetings'>Back to Home </Link>
        </Box>
      ) : (
        <>
          <Box>
            <UserAvatar />
          </Box>

          <Box p={5}>
            <Box>
              <UserInfo />
            </Box>
            <Box mt={2}>
              <About />
            </Box>
            <Box mt={2}>
              <PublicMeetings />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};
